// extracted by mini-css-extract-plugin
var _1 = "PreviewBlock_active__fb688";
var _2 = "PreviewBlock_blockActions__10eac";
var _3 = "PreviewBlock_canvas__80971";
var _4 = "PreviewBlock_comments__156da";
var _5 = "PreviewBlock_isComment__ac535";
var _6 = "PreviewBlock_isDone__d7a2e";
export { _1 as "active", _2 as "blockActions", _3 as "canvas", _4 as "comments", _5 as "isComment", _6 as "isDone" }
